export const objectKeys = <Obj extends object>(obj: Obj): (keyof Obj)[] => Object.keys(obj) as (keyof Obj)[];
